import { atom } from 'jotai';

import type { TrackTeamTrialUpgradeRequestSubmit } from '../../../contracts/team-trial-upgrade-request-analytics.types';

export type TeamSeatUpgradeRequestModalAtomValue =
  | { isOpen: false }
  | {
      isOpen: true;
      /** The submit emit, bound by whoever opened the modal so it reports the origin's screen. */
      trackRequestSubmitted: TrackTeamTrialUpgradeRequestSubmit;
      /**
       * Recommend and preselect the Max seat. Team usage is admin-only, so a
       * member's caller usually cannot know and leaves this off.
       */
      isMaxSeatRecommended?: boolean;
      onRequestSent?: () => void;
      onUserDismiss?: () => void;
    };

export const teamSeatUpgradeRequestModalAtom = atom<TeamSeatUpgradeRequestModalAtomValue>(
  {
    isOpen: false,
  }
);

export type OpenTeamSeatUpgradeRequestModalPayload = Omit<
  Extract<TeamSeatUpgradeRequestModalAtomValue, { isOpen: true }>,
  'isOpen'
>;

/** Set by callers to open the globally mounted {@link TeamSeatUpgradeRequestModal}. */
export const openTeamSeatUpgradeRequestModalAtom = atom(
  null,
  (_get, set, payload: OpenTeamSeatUpgradeRequestModalPayload) => {
    set(teamSeatUpgradeRequestModalAtom, { isOpen: true, ...payload });
  }
);

export const closeTeamSeatUpgradeRequestModalAtom = atom(null, (_get, set) => {
  set(teamSeatUpgradeRequestModalAtom, { isOpen: false });
});
